import I18N from '@/locales/I18N';
import { isTestEnv } from '@/util/dev-tool';

const MICROAPP_CONTAINER_ID = 'dcl-micro-app';
const LS_LAST_PRODUCT_KEY = 'aisee-last-product';

// import-map-overrides 工具包地址
const IMPORT_MAP_OVERRIDES =
  'https://mfdclcommon-75970.gzc.vod.tencent-cloud.com/import-map-overrides-cn-by-extronwang.js';
const IWIKI_LINK =
  'https://iwiki.woa.com/pages/viewpage.action?pageId=754659426';
const AISEE_ORIGIN = 'http://aisee.oa.com';
const TESTONE = 'http://testone.woa.com/product-manager#/product/my/base';

const GUIDANCE_DOC = {
  link: 'https://iwiki.woa.com/p/4012163356',
  text: I18N.constant.guidanceDocument,
};

const GUIDANCE_ROBOT_DOC = {
  link: 'https://iwiki.woa.com/p/4014001557#16-%E7%BE%A4%E6%8E%A8%E9%80%81',
  text: I18N.constant.guidanceDocument,
};

// 小助手
const WX_HELPER = {
  text: I18N.constant.contactTheAssistant,
  // 服务号id需要联系 “内部客服助手” 获取
  link: 'wxwork://message?uin=8444251120322059',
};

// OBS
const OBS_LINK = {
  text: '去OBS查看',
  link: 'https://obs.woa.com/new-obs/r/baseInfo/product/operateProduct',
};
const LOG_GUIDE = {
  link: 'https://iwiki.woa.com/p/4013119866',
  text: I18N.constant.logAnalysisIsTheMost,
};

// 接入指南
const OnBoardingGuide = {
  link: 'https://iwiki.woa.com/p/4012163381',
  text: '接入指南',
};

const PRODUCT_TEXT = {
  text: I18N.constant.productRegistration,
};

const USER_SELECT_PRODUCT = 'userSelectProduct';

// 注册的反馈产品 Id（公钥改为进入页面后按当前 appId 拉取，不再写死）
const FPRODUCT_ID = {
  formal: '086aa5c72f',
  test: '97ccaf7c69',
};

const FEEDBACK_ISSUE_URL = {
  formal: 'https://h5.dcl.qq.com',
  test: 'https://h5dcl.testsite.woa.com',
};

/**
 * 一键接入新产品的测试环境id
 */
const ONECLICK_PRODUCT_TEST_ID =
  '/p-991cf2fb-b307-3351-bd2a-2c1c293067d1/b-c475442e-f754-3334-bcce-ffb20b1ebab3/';

/**
 * 一键接入新产品的正式环境id
 */
const ONECLICK_PRODUCT_APPID =
  '/p-548d68c4-688c-3286-940d-3ec000459c2c/b-05b2763f-ce3f-3bb8-ad5c-11b2e50eac8b/';
// AISEE_APPID
const AISEE_APPID = 'xauer5xqx9';

// 海外正式环境体验环境APPID
const OVERSEA_FORMAL_APPID = '97ccaf7c69';
// 体验Demo_APPID
const DEMO_APPID = '32a2a0e053';

// 私有项目，用于仅为AISEE开启接口
const PRIVATE_PROJECTS = [AISEE_APPID, OVERSEA_FORMAL_APPID];

const getReportIssueInfo = () => {
  if (isTestEnv()) {
    return {
      url: FEEDBACK_ISSUE_URL.test,
      appId: FPRODUCT_ID.test,
    };
  }
  return {
    url: FEEDBACK_ISSUE_URL.formal,
    appId: FPRODUCT_ID.formal,
  };
};

// 限制访问的Dept组
const RESTRICT_DEPT = [
  'CSIG云与智慧产业事业群/CSIG质量部/地图产品质量中心',
  'IEG互动娱乐事业群/品质管理部/WeTest产品中心',
  '公司其他组织/腾讯音乐娱乐/QQ音乐业务线',
  '子公司组织/运营子公司/TEG-客户服务部',
  'TEG技术工程事业群/客户服务部',
];

/**
 * 系统信息映射
 * key: 系统名称
 * value: { 名称, 短名称, 图标 }
 * @type {Map<string, { name: string, sname: string, icon: string }>}
 */
const SYSTEM_INFO_MAP = new Map([
  ['alarm', { name: '告警(alarm)', sname: '告警', icon: 'alarm2' }],
  [
    'intelligence',
    { name: 'intelligence', sname: 'intelligence', icon: 'sysAvatar' },
  ],
  ['system', { name: '系统(system)', sname: '系统', icon: 'sysAvatar' }],
  ['plugin', { name: '插件(plugin)', sname: '插件', icon: 'sysAvatar' }],
  ['tpilot', { name: 'tpilot', sname: 'tpilot', icon: 'sysAvatar' }],
  [
    'system-scheduler',
    {
      name: '系统调度(system-scheduler)',
      sname: '系统调度',
      icon: 'sysAvatar',
    },
  ],
]);

export {
  AISEE_ORIGIN as aiseeOrigin,
  DEMO_APPID,
  getReportIssueInfo,
  GUIDANCE_DOC as guidanceDoc,
  GUIDANCE_ROBOT_DOC as guidanceRobotDoc,
  IMPORT_MAP_OVERRIDES,
  IWIKI_LINK,
  LOG_GUIDE as logguide,
  LS_LAST_PRODUCT_KEY,
  MICROAPP_CONTAINER_ID,
  OBS_LINK as obsLink,
  OnBoardingGuide as onBoardingGuide,
  ONECLICK_PRODUCT_APPID,
  ONECLICK_PRODUCT_TEST_ID,
  PRIVATE_PROJECTS,
  PRODUCT_TEXT as ptext,
  RESTRICT_DEPT as restrictDept,
  SYSTEM_INFO_MAP,
  TESTONE as testOne,
  USER_SELECT_PRODUCT as usproduct,
  WX_HELPER as wxhelper,
};
